import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Eye, EyeOff, ChevronDown, X, User, Mail, Lock, CreditCard, Briefcase } from 'lucide-react';
import '../../../assets/css/components/serviceprovider/auth/workerloginmodal/WorkerLoginModal.css';
import AppContext from '../../../context/AppContext';
import OneSignal from 'react-onesignal';
// import Swal from 'sweetalert2';
import axios from 'axios';


const WorkerRegister = ({ onClose, isOpen, onLoginSuccess }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [category, setCategory] = useState([]);

  const { baseUrl, setAuthToken, RegExpChecker ,loginWorkerToOneSignal,setWorkerProfile} = useContext(AppContext);


  const [mode, setMode] = useState("login");
  // add states
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [ssn, setSsn] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectservice, setSelectService] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);


  // SignUp  create
  const handleSignup = () => {
    setLoading(true);

    const formData = new FormData();

    formData.append("fullName", fullName);
    formData.append("email", email);
    formData.append("password", password);

    formData.append("whcategory_id", selectservice);
    // formData.append("ssn", ssn);

    formData.append("phoneNumber", phoneNumber);

  axios.post(`${baseUrl}/worker/workersignup`, formData)
  .then(async (response) => {

        if (response.data.success) {

          localStorage.setItem("authToken", response.data.token);

await loginWorkerToOneSignal(
  response.data.serviceprovider.id
);

          // email
          localStorage.setItem("email", email);
localStorage.setItem(
   "worker",
   JSON.stringify(response.data.serviceprovider)
);

          // hashed password
          localStorage.setItem(
            "password",
            response.data.serviceprovider.password
          );

          setAuthToken(response.data.token);
          setWorkerProfile(response.data.serviceprovider);

          navigate("/worker-dashboard");
        }

      })
      .catch((err) => {
        setLoading(false);

        const message = err.response?.data?.message;

        setErrors({
          email: message === "Email already exists." ? message : ""
        });
      });
  };


  // Login

  const handleLogin = () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("type", "login");
  axios.post(`${baseUrl}/worker/workerlogin`, formData)
  .then(async response => {
        setLoading(false);
        console.log("Login Response:", response.data);

       if (response.data.token) {

    localStorage.setItem("authToken", response.data.token);

    localStorage.setItem(
      "worker",
      JSON.stringify(response.data.serviceprovider)
    );

    setAuthToken(response.data.token);
    setWorkerProfile(response.data.serviceprovider);

    localStorage.setItem("email", email);

    localStorage.setItem(
      "password",
      response.data.serviceprovider.password
    );

    localStorage.setItem(
      "availability",
      response.data.serviceprovider.availablity
    );

    // OneSignal
    await loginWorkerToOneSignal(
      response.data.serviceprovider.id
    );

    navigate("/worker-dashboard");

    onLoginSuccess && onLoginSuccess();
}else {

        }
      })
      .catch((err) => {
        setLoading(false);

        const message = err.response?.data?.message;

        setErrors({
          email: message === "No account found with this email." ? message : "",
          password: message === "Incorrect password." ? message : ""
        });
      });
  };


  // Auto Login 
  useEffect(() => {
    if (location.pathname !== "/") return;

    let email = localStorage.getItem("email");
    let password = localStorage.getItem("password");



    if (email && password) {
      workerAutoLogin(email, password, navigate);
    }
  }, [location.pathname, navigate]);


  const workerAutoLogin = (email, password, navigate) => {
    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("type", "autologin");

    axios.post(`${baseUrl}/worker/workerlogin`, formData)
.then(async response => {
          setLoading(false);
        console.log(response.data);
        if (response.data.token) {
          localStorage.setItem("authToken", response.data.token);
          localStorage.setItem(
   "worker",
   JSON.stringify(response.data.serviceprovider)
);
          setAuthToken(response.data.token);
           await loginWorkerToOneSignal(
    response.data.serviceprovider.id
  );
          navigate("/worker-dashboard");

          // setTimeout(() => {
          // onLoginSuccess && onLoginSuccess();
          // }, 100);
        }

      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };



  // category call karna k liya drop down mey 
  useEffect(() => {
    axios.get(`${baseUrl}/user/viewcategory`)
      .then((response) => {

        ;

        setCategory(response.data.categories);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);





  // Errors
  // const set = (key, val) => {
  //   setForm(p => ({ ...p, [key]: val }));
  //   setErrors(p => ({ ...p, [key]: '' }));
  // };

  // VALIDATION
  const validate = () => {
    const e = {};

    if (!email.trim()) {
      e.email = "Email is required";
    } else {
      const emailErr = RegExpChecker("email", email);
      if (emailErr.email) e.email = emailErr.email;
    }
    //passwor
    if (!password.trim()) {
      e.password = "Password is required";
    } else {
      const passwordErr = RegExpChecker("password", password);
      if (passwordErr.password) e.password = passwordErr.password;
    }


    if (mode === "register") {


      // Full Name
      if (!fullName.trim()) {
        e.fullName = "Full name is required";
      }
      else {
        const nameErr = RegExpChecker("fullName", fullName);
        if (nameErr.fullName) e.fullName = nameErr.fullName;
      }


      //cnic
      // if (!ssn.trim()) {
      //   e.ssn = "SSN is required";
      // } else {
      //   const ssnErr = RegExpChecker("ssn", ssn); // (agar CNIC format same treat karna hai)
      //   if (ssnErr.ssn) e.ssn = ssnErr.ssn;
      // }
      // Phone
      // Phone
      if (!phoneNumber.trim()) {
        e.phoneNumber = "Phone number is required";
      } else {
        const phoneErr = RegExpChecker("phone", phoneNumber);

        if (phoneErr.phone) {
          e.phoneNumber = phoneErr.phone;
        }
      }


      if (!selectservice) {
        e.service = "Service is required";
      }
    }

    return e;
  };
  const handleSubmit = () => {
    const e = validate();

    if (Object.keys(e).length) {
      setErrors(e);
      return;
    }

    setLoading(true);

    if (mode === "register") {
      handleSignup();
    } else {
      handleLogin();
    }
  };



  //  Google Login
//  const handleGoogleLogin = () => {

//     const type = mode === "login" ? "login" : "signup";

//     window.location.href =
//     `${baseUrl}/worker/auth/google?type=${type}`;

// };

  //  Forgot Password
 const handleForgotPassword = () => {
  navigate("/worker-forget-password");
};
  const clearFieldError = (field, value, setter) => {
    setter(value);

    setErrors((prev) => ({
      ...prev,
      [field]: ""
    }));
  };
  return (
    <div className="wr-overlay" onClick={onClose}>
      <div className="wr-modal" onClick={e => e.stopPropagation()}>

        <button className="wr-close" onClick={onClose}><X size={18} /></button>

        <h3 className="wr-title">
          {mode === "register" ? "Create Account" : "Responder Login"}
        </h3>

        <p className="wr-sub">
          {mode === "register"
            ? "Join as a service professional"
            : "Login to your account"}
        </p>

        <div className="wr-fields">

          {mode === "register" && (


            <div className={`wr-field ${errors.fullName ? 'wr-field--err' : ''}`}>
              <div className="wr-input-wrap">
                <User size={16} className="wr-icon" />
                <input
                  className="wr-input"
                  type="text"
                  placeholder="Full Name"
                  value={fullName}
                  onChange={e => clearFieldError("fullName", e.target.value, setFullName)} />
              </div>
              {errors.fullName && <span className="wr-err">{errors.fullName}</span>}
            </div>


          )}
          {mode === "register" && (
            <>
              <div className={`wr-field ${errors.fullName ? 'wr-field--err' : ''}`}>

              </div>

              {/* PHONE NUMBER */}
              <div className="wr-field">
                <div className="wr-input-wrap">
                  <User size={16} className="wr-icon" />
                  <input
                    className="wr-input"
                    type="text"
                    placeholder="Phone Number"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
                {errors.phoneNumber && (
                  <span className="wr-err">{errors.phoneNumber}</span>
                )}
              </div>
            </>
          )}

          <div className={`wr-field ${errors.email ? 'wr-field--err' : ''}`}>
            <div className="wr-input-wrap">
              <Mail size={16} className="wr-icon" />
              <input
                className="wr-input"
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={e => clearFieldError("email", e.target.value, setEmail)}

              />
            </div>
            {errors.email && <span className="wr-err">{errors.email}</span>}
          </div>

          <div className={`wr-field ${errors.password ? 'wr-field--err' : ''}`}>
            <div className="wr-input-wrap">
              <Lock size={16} className="wr-icon" />
              <input
                className="wr-input"
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={e => clearFieldError("password", e.target.value, setPassword)}
              />
              <button className="wr-eye" type="button" onClick={() => setShowPassword(p => !p)}>
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            {errors.password && <span className="wr-err">{errors.password}</span>}
          </div>

{/*     
          {mode === "register" && (
            <div className={`wr-field ${errors.ssn ? 'wr-field--err' : ''}`}>
              <div className="wr-input-wrap">
                <CreditCard size={16} className="wr-icon" />

                <input
                  className="wr-input"
                  type="text"
                  placeholder="SSN"
                  value={ssn}
                  onChange={(e) => {
                    setSsn(e.target.value);

                    setErrors((prev) => ({
                      ...prev,
                      ssn: ""
                    }));
                  }}
                />
              </div>

              {errors.ssn && (
                <span className="wr-err">{errors.ssn}</span>
              )}
            </div>
          )} */}

          {mode === "register" && (
            <div className={`wr-field ${errors.service ? 'wr-field--err' : ''}`}>
              <div className="wr-input-wrap wr-select-wrap">
                <Briefcase size={16} className="wr-icon" />
                <select
                  className="wr-input wr-select"
                  value={selectservice}
                  onChange={e => clearFieldError("service", e.target.value, setSelectService)}
                >
                  <option value="">Select Service</option>
                  {/* fetch category in service drop down  */}

                  {category.map((cat) => (
                    <option value={cat.id}>
                      {cat.categoryName}
                    </option>
                  ))}
                </select>
                <ChevronDown size={16} className="wr-chevron" />
              </div>
              {errors.service && <span className="wr-err">{errors.service}</span>}
            </div>
          )}

        </div>

        <button
          className={`wr-submit ${loading ? 'wr-submit--loading' : ''}`}
          onClick={handleSubmit}
        >
          {loading
            ? 'Please wait...'
            : mode === "register"
              ? 'Sign Up'
              : 'Login'}
        </button>

        {/* NEW: Google Button */}
        {/* <button
          type="button"
          className="wr-google-btn"
          onClick={handleGoogleLogin}
        >
          Continue with Google
        </button> */}

        {/* NEW: Forgot Password */}
        {mode === "login" && (
          <p className="wr-forgot" onClick={handleForgotPassword}>
            Forgot Password?
          </p>
        )}

        <p className="wr-login-link">
          {mode === "register"
            ? "Already have an account? "
            : "Don't have an account? "}

          <button
            className="wr-login-btn"
            onClick={() => setMode(mode === "register" ? "login" : "register")}
          >
            {mode === "register" ? "Login" : "Register"}
          </button>
        </p>

      </div>
    </div>
  );
};

export default WorkerRegister;